import type { BookWithMeModule } from '../store/schema/BookWithMeRoutesStore';
import store from '../store/Store';

export default function (): BookWithMeModule | null {
    return store.currentModule;
}
